import styled from "styled-components";

import Container from "features/shared/styles/container/Container-DEFAULT.styled";
import PaxDetails from "../components/passenger-info/styles/PaxDetails.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";

interface JourneyContainerProps {
  isPaxVisible: boolean;
}
const JourneyContainer = styled(Container)<JourneyContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  ${PaxDetails} ${Summary} {
    font-weight: 600;
  }
`;

export default JourneyContainer;
